/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCarrierScorecard.ts              *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/carrier-scorecard";

export class AutogenModelCarrierScorecard<RowType extends ModelRow> extends Endpoint<RowType, RowCarrierScorecardFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCarrierScorecard extends ModelRow<RowCarrierScorecardFields> {
	constructor(values?: Partial<RowCarrierScorecardFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCarrierScorecardFields {
	account_manager: string;
	carrier_acc_filters: string;
	company_id: string;
	customer_acc_filters: string;
	exclude_location: string;
	exclude_order_mode: string;
	exclude_order_type: string;
	exclude_revenue_code: string;
	export_load_option: string;
	export_load_options: string;
	frequency: number;
	location_list: string;
	order_mode_list: string;
	order_types_list: string;
	password: string;
	reporting_date_option: string;
	reporting_date_options: string;
	revenue_code_list: string;
	user_name: string;
	vendor_id: string;
	webservice_address: string;
}

